import React, { Component } from 'react';
import $ from 'jquery';
import axios from "axios";
import { setCookie, getCookie, loginUrl, pocketUrl, sleep } from './Common';
import Swiper from 'swiper';
import 'swiper/css';

class SecRenew extends Component {
  constructor(props) {
    super(props);
    this.swiper = null;
    this.state = {
      dataList: [],     // 배열 데이터를 담음
      loading: true,
      error: null
    };
  }
//
  async componentDidMount() {
    const publicUrl = process.env.PUBLIC_URL;
    try {
      sleep(500);
      const response = await axios.get(publicUrl + '/api/getReviewWord.php');
      sleep(500);
      this.setState({
        dataList: response.data,  // 예: [{id:1, title:'a'}, {id:2, title:'b'}]
        loading: false
      });
    } catch (error) {
      this.setState({
        error: error.message,
        loading: false
      });
      console.log('data error:' + error);
    };
  }
  handleButtonClick = async (targetIdx) => {
    const element = document.getElementById(`sbtn-${targetIdx}`);

    const { dataList } = this.state;
    const foundIndex = dataList.findIndex(item => item.idx === targetIdx);
    if (foundIndex === -1) return;

    const isZzim = dataList[foundIndex].uzzim;
    const md = isZzim ? 'unsetZzim' : 'setZzim';

    try {
      const ret = await setWord(md, targetIdx);

      const newZzim = ret === 'setZzim';

      // 클래스 업데이트
      requestAnimationFrame(() => {
        element.className = newZzim ? 'zzim active' : 'zzim';
        void element.offsetHeight; // for iOS
      });

      // 상태 업데이트
      this.setState(prev => {
        const updated = [...prev.dataList];
        updated[foundIndex] = {
          ...updated[foundIndex],
          uzzim: newZzim
        };
        return { dataList: updated };
      });
      const container = document.querySelector('.wordSwiper .swiper-container');
      if (container) {
        if (this.swiper) {
          this.swiper.update(); // 이미 존재하면 업데이트만
        } else {
          this.initSwiper(); // 처음이면 초기화
        }
      }

    } catch (err) {
      console.error('처리 실패:', err);
    }
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.dataList !== this.state.dataList &&
      this.state.dataList.length >= 2
    ) {
      setTimeout(() => {
        const container = document.querySelector('.wordSwiper .swiper-container');
        if (container) {
          if (this.swiper) {
            this.swiper.update(); // 이미 존재하면 업데이트만
          } else {
            this.initSwiper(); // 처음이면 초기화
          }
        } else {
          console.warn('swiper-container가 아직 DOM에 없습니다.');
        }
      }, 50);
    }
  }
  initSwiper() {
    if (this.swiper) this.swiper.destroy(true, true); // 기존 인스턴스 제거
    this.swiper = new Swiper(".wordSwiper .swiper-container", {
      speed: 1e3,
      grabCursor: true,
      loop: false,
      slidesPerView: "auto",
      centeredSlides: false,
      centeredSlidesBounds: true,
      spaceBetween: 16,
      observer: false,
      observeParents: false,

    })
  }
  render() {
    const { dataList, loading, error } = this.state;
    //
    return (
      <section className="section section--remind">
        <div className="title-bx">
          <h2 className="tit"> 용어 다시알기 </h2>
        </div>
        <></>
        <div className="wordSwiper">
          <div className="swiper-container">
            <div className="swiper-wrapper">
              {dataList.slice(0, 5).map((item, index) => (
                <div key={item.id || index} className="swiper-slide item">
                  <article className="word-card">
                    <button id={`sbtn-${item.idx}`} type="button" className={item.uzzim ? 'zzim active' : 'zzim'} onClick={() => this.handleButtonClick(item.idx)}>
                      <svg width="24" height="22" id={`svg-${item.idx}`} viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" fillOpacity="0">
                        <use xlinkHref="#zzim"></use>
                      </svg>
                      <span className="sr-only">찜하기 해제</span>
                    </button>
                    <a href={item ? `/View/${item.idx}` : '#'} className="wrap">
                      <div className="quote-wrap">
                        <svg width="16" height="12" viewBox="0 0 16 12"><use xlinkHref="#quote"></use></svg>
                        <svg width="16" height="12" viewBox="0 0 16 12"><use xlinkHref="#quote"></use></svg>
                        <p className="tit">
                          <span>{item.title}</span>
                        </p>
                      </div>
                      <p className="eng">{item.subtitle}</p>
                      <p className="desc">{item.description}</p>
                    </a>
                  </article>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
function userZzim(idx) {
  //const uzzim =
  let uz_fillopacity = $("#svgZzim").attr("fill-opacity");
  let md;
  if (uz_fillopacity == 0) {
    $("#svgZzim").attr("fill-opacity", 1);
    md = 'setZzim';
  } else {
    $("#svgZzim").attr("fill-opacity", 0);
    md = 'unsetZzim';
  }
  setWord(md, idx);
}

async function setWord(md, idx) {
  const publicUrl = process.env.REACT_APP_POCKET_WWW;
  setCookie('JUMP_URI', publicUrl);
  try {
    const response = await axios.get(publicUrl + '/api/setWord.php?md=' + md + '&idx=' + idx);
    if (response.data == 'NO') {

      const refUrl = process.env.REACT_APP_USER_WWW + '/snslogin/PocketLogingDone.php?loc=&idx=' + idx;
      window.location.href = loginUrl + '?ref=' + encodeURIComponent(refUrl);

    }
    return response.data;
  } catch (error) {
    console.log(error.message);
    return false;
  };
}
export default SecRenew;    